import styled from 'styled-components'

export default styled.span`
    font-size: 12px;
    color: ${props => props.theme.p}
`
